export default __webpack_public_path__ + "static/cloud_saas_casestudy-1679b41e7a610d434e26d72fab03dd17.svg";